import { render, staticRenderFns } from "./RollUserBets.vue?vue&type=template&id=2f395273&scoped=true"
import script from "./RollUserBets.vue?vue&type=script&lang=js"
export * from "./RollUserBets.vue?vue&type=script&lang=js"
import style0 from "./RollUserBets.vue?vue&type=style&index=0&id=2f395273&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f395273",
  null
  
)

export default component.exports